"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const Hidden_1 = require("./Hidden");
exports.Backdrop = styled_1.default(Hidden_1.Hidden) `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-tap-highlight-color: rgba(0, 0, 0, 0);
  ${styled_tools_1.theme('Backdrop')};
`;
exports.Backdrop.defaultProps = {
    role: 'button',
    tabIndex: -1,
    opaque: true,
    palette: 'shadow',
    tone: 2,
};

//# sourceMappingURL=Backdrop.js.map
